import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'));
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'));
  const loading = ref(false);
  const error = ref(null);
  const isAuthenticated = computed(() => token.value !== null);

  async function register(name, phone, password, referralCode = '') {
    loading.value = true;
    error.value = null;
    try {
      const { data } = await axios.post(`${API_URL}/auth/register`, { name, phone, password, referralCode });
      token.value = data.token;
      user.value = data.user;
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      return data;
    } catch (err) {
      const msg = err.response?.data?.error || 'Помилка реєстрації';
      error.value = msg;
      throw msg;
    } finally {
      loading.value = false;
    }
  }

  async function login(phone, password) {
    loading.value = true;
    error.value = null;
    try {
      const { data } = await axios.post(`${API_URL}/auth/login`, { phone, password });
      token.value = data.token;
      user.value = data.user;
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      return data;
    } catch (err) {
      const msg = err.response?.data?.error || 'Невірний номер або пароль';
      error.value = msg;
      throw msg;
    } finally {
      loading.value = false;
    }
  }

  function logout() {
    token.value = null;
    user.value = null;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  return { token, user, loading, error, isAuthenticated, register, login, logout };
});
